import { render } from "./BaseWarningIcon.vue?vue&type=template&id=dc92a1c0"
import script from "./BaseWarningIcon.vue?vue&type=script&lang=js"
export * from "./BaseWarningIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__